// Log levels
const levels = {
  debug: 3,
  info: 2,
  warn: 1,
  error: 0,
};

// From Webpack Env Config
const { showConsoleLogs } = __OPTIONS__; // eslint-disable-line no-undef
// const showConsoleLogs = false;

// Logger singleton implementation
class Logger {
  constructor() {
    this.level = levels.info;
    this.silent = !showConsoleLogs;
  }

  static getLevels() {
    return levels;
  }

  updateLevel(level) {
    this.level = level;
  }

  group(label) {
    if (this.level >= levels.info && !this.silent) {
      console.group(label); // eslint-disable-line no-console
    }
  }

  groupEnd(label) {
    if (this.level >= levels.info && !this.silent) {
      console.groupEnd(label); // eslint-disable-line no-console
    }
  }

  debug(msg, data) {
    if (this.level >= levels.debug && !this.silent) {
      console.log(msg, data); // eslint-disable-line no-console
    }
  }

  info(msg, data) {
    if (this.level >= levels.info && !this.silent) {
      console.info(msg, data); // eslint-disable-line no-console
    }
  }

  warn(msg, data) {
    if (this.level >= levels.warn && !this.silent) {
      console.warn(msg, data); // eslint-disable-line no-console
    }
  }

  error(msg, data) {
    if (this.level >= levels.error && !this.silent) {
      console.error(msg, data); // eslint-disable-line no-console
    }
  }
}

const logger = new Logger();
Object.freeze(logger);

export default logger;



// WEBPACK FOOTER //
// ./logger/logger.js